export default __webpack_public_path__ + "static/media/Boots of the Revelations of Tarim.eae5a5d2.jpg";